import { API_WALLET_URL, API_LOANS_URL, URL_ME } from 'config'

import { apiCall } from './base'

export const CREDIT_TYPES_SLUG = {
  ADVANCE_ZERO_RATE: 'interest-free-advances',
  ADVANCE_DEFAULT: 'cash-advances',
  LOAN: 'personal-loan'
}

export const CREDIT_PRODUCT = {
  LOANS: 'loans',
  WALLET: 'wallet'
}

export const getOffer = (product = CREDIT_PRODUCT.WALLET) =>
  apiCall(`credits/v1/${product}/lines`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })

export const getAdvancePlans = (
  amount,
  type = CREDIT_TYPES_SLUG.ADVANCE_DEFAULT
) =>
  apiCall(`credits/v1/wallet/${CREDIT_TYPES_SLUG[type]}/options/${amount}`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })

export const acceptAdvanceTerms = (data) =>
  apiCall(`${URL_ME}/api/v1/me/loan/terms/ADELANTO`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })

export const finishAdvance = (data) =>
  apiCall(`${URL_ME}/api/v2/me/loan/attempt`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })

export const getPaidAdvances = () =>
  apiCall(`credits/v1/wallet/advances/payed`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => {
    if (res.success) {
      // return res.data?.result
      return null
    }
  })

export const getCreditLinesSummary = (creditProduct = CREDIT_PRODUCT.WALLET) =>
  apiCall(`credits/v1/${creditProduct}/lines/summaries`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => {
    if (res.success) {
      const data = res.data.result

      const { is_valid: isValid, expires_at: expiresAt } = data

      const {
        allocated_amount: allocatedAmount,
        remaining_amount: remainingAmount,
        approved_amount: approvedAmount
      } = data.balance

      let summary = {
        isValid,
        expiresAt,
        allocatedAmount,
        remainingAmount: remainingAmount < 0 ? 0 : remainingAmount,
        approvedAmount,
        isDepleted: isValid && remainingAmount <= 0 && allocatedAmount > 0,
        isZero:
          (isValid && allocatedAmount === 0 && approvedAmount === 0) ||
          remainingAmount < 0
      }

      if (data.balance.interest_free_advances) {
        summary = {
          ...summary,
          interestFreeRemainingAmount:
            data.balance.interest_free_advances.remaining_amount,
          interestFreeApprovedAmount:
            data.balance.interest_free_advances.approved_amount,
          interestFreeIsDepleted:
            isValid &&
            data.balance.interest_free_advances.remaining_amount <= 0 &&
            data.balance.interest_free_advances.allocated_amount > 0
        }
      }

      return summary
    }
  })

export const getAdvanceTerms = () =>
  apiCall(`v3/terms`, {
    baseURL: API_LOANS_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  }).then((res) => res.data.model.data)

export const getCreditHistory = ({ page = 1, creditProduct, states }) =>
  apiCall(
    `credits/v1?page=${page}&credit-product=${creditProduct.toLowerCase()}&states=${states}`,
    {
      baseURL: API_LOANS_URL,
      method: 'GET',
      withCredentials: false,
      immediately: true
    }
  ).then((res) => {
    if (res.success) {
      const { result } = res.data
      return {
        currentPage: result.current_page,
        lastPage: result.last_page,
        data: result.data
      }
    }
  })
